import { savePostLoginRedirect } from '~/composables/usePostLoginRedirect';

// Exported for testing - handles portal redirect logic
export function handlePortalRedirect(to: any): string | undefined {
  // Skip if no portal param
  if (!to.query.portal) {
    return undefined;
  }

  const portalParam = to.query.portal as string;

  // Handle empty string portal param
  if (!portalParam.trim()) {
    return undefined;
  }

  // Build clean URL (remove portal parameter, keep others)
  const url = new URL(to.fullPath, window.location.origin);
  url.searchParams.delete('portal');
  const cleanUrl = url.pathname + (url.search || '');

  // Save URL for redirect after auth check
  // Works for both authenticated (immediate redirect) and unauthenticated (post-login redirect)
  savePostLoginRedirect(cleanUrl, { force: true, source: 'portal-redirect' });

  // Return the login URL to redirect to
  const cleanPortal = portalParam.trim().toLowerCase();
  return `/login/${cleanPortal}`;
}

export default defineNuxtRouteMiddleware((to: any) => {
  // Only run client-side (static site on S3)
  if (!import.meta.client) {
    return;
  }

  const redirectUrl = handlePortalRedirect(to);
  if (redirectUrl) {
    return navigateTo(redirectUrl);
  }
});
